import IconNameEnum from "constants/IconNameEnum";
import React, { DOMAttributes } from "react";
import { Button, Dropdown } from "react-bootstrap";
import BaseIcon from "../base-form/BaseIcon";
import BaseLabel from "../base-form/BaseLabel";

export type BaseDropdownItem = {
    label: string;
    code: string;
    icon?: IconNameEnum;
    className?: string;
};

interface IProps {
    items: BaseDropdownItem[];
    customToggleId?: string;
    customToggleColor?: "light";
    customToggleElement?: JSX.Element;
    customToggleLabel?: string;
    customToggleHoverTitle?: string;
    customToggleIcon?: IconNameEnum;
    className?: string;
    onClickHandler: (code: string) => void;
    selectedItem?: string;
    selectToggle?: boolean;
    readonly?: boolean;
}

interface IState {
    isOpen: boolean;
}

class BaseDropdown extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: false,
        } as IState;
    }

    private hasUnmounted = false;

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private onToggle = (isOpen?: boolean) => {
        if (this.hasUnmounted === false) {
            this.setState({
                isOpen: isOpen!,
            });
        }
    };

    private customToggle = React.forwardRef<any, DOMAttributes<any>>(({ onClick }, ref) => (
        <Button
            type="button"
            variant={this.props.customToggleColor ?? "link"}
            className={[
                "text-decoration-none",
                this.props.customToggleElement ? "p-0 m-0 border-0" : "",
                this.props.customToggleColor === "light" ? "bg-ccq-default cq-text-blue ccq-shadow" : "text-inherit",
                this.props.customToggleIcon && this.props.customToggleLabel === undefined
                    ? "rounded-circle p-2 ccq-circle-button"
                    : "",
            ].join(" ")}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                this.onToggle();
                if (onClick) {
                    onClick(e);
                }
            }}
            title={this.props.customToggleHoverTitle}
        >
            {this.props.customToggleElement ? (
                <>{this.props.customToggleElement}</>
            ) : (
                <>
                    <BaseIcon
                        icon={
                            this.props.customToggleIcon ??
                            (this.state.isOpen ? IconNameEnum.MenuChiudi : IconNameEnum.MenuApri)
                        }
                    />
                    {this.props.customToggleLabel ? (
                        <>
                            <span className="clearfix"></span>
                            <span
                                className={[
                                    "d-none d-lg-inline-block align-middle small",
                                    this.props.selectToggle ? "font-weight-bolder cq-text-blue" : "",
                                ].join(" ")}
                            >
                                {this.props.customToggleLabel}
                            </span>
                        </>
                    ) : null}
                </>
            )}
        </Button>
    ));

    public render(): JSX.Element {
        const { className, items, onClickHandler, selectedItem, customToggleLabel, readonly } = this.props;

        return (
            <Dropdown
                className={["d-inline", className].join(" ")}
                onToggle={(isOpen: boolean) => this.onToggle(isOpen)}
            >
                <Dropdown.Toggle
                    as={this.customToggle}
                    id={this.props.customToggleId ? this.props.customToggleId : "dropdown-toggle"}
                />
                <Dropdown.Menu alignRight={customToggleLabel ? false : true} className={"ccq-shadow"}>
                    {items.map((item: BaseDropdownItem, index: number) => (
                        <Dropdown.Item
                            key={index}
                            className={[
                                readonly ? "text-ccq-default" : "",
                                item.code === selectedItem ? "bg-ccq-active-dropdown" : "",
                                item.className,
                            ].join(" ")}
                            onClick={() => onClickHandler(item.code)}
                            disabled={readonly}
                        >
                            <BaseLabel icon={item.icon} label={item.label} />
                        </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
            </Dropdown>
        );
    }
}

export { BaseDropdown as Unconnected };
export default BaseDropdown;
